export default __webpack_public_path__ + "static/media/fb.2c80d1a8.svg";